'use strict';

exports.__esModule = true;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]);


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-leaflet/lib/propTypes/children.js
 ** module id = 40
 ** module chunks = 0
 **/